const base = require('./base')

module.exports = Object.assign({}, base, {
  ENV: 'PROD',
  API_VERSION: 'v1',
  LOGGER_URL: 'http://127.0.0.1:3050/v1/log'
})
